



$(window).on('load', function() {
    // remove overlay after loaded page
    $('.content-overlay').removeClass('overlay-block').find('.overlay-layer').remove();

});
